import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["later", "add", "deleteCategory", "editCategory"];
  connect() {
    const addBtn = this.addTargets[0];
    if (addBtn) {
      addBtn.addEventListener("click", (_) => {
        const modal = document.getElementById("add-custom-category-modal");
        $(modal).fadeIn("slow");
      });
    }
  }
  maybeLater() {
    const url = this.laterTargets[0].dataset.url;
    const token = getMetaValue("csrf-token");
    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json",
      },
      credentials: "include",
    }).then((response) => {
      if (response.ok) {
        const customCategoryBadge = document.querySelector(
          ".custom-category__badge"
        );
        const elementsWithCategoryAlert = document.querySelectorAll(
          ".with-category-alert"
        );
        elementsWithCategoryAlert.forEach((element) => {
          element.classList.remove("with-category-alert");
        });
        customCategoryBadge.remove();
        this.element.remove();
      } else {
        console.error("Failed to modify session");
      }
    });
  }

  async delete() {
    const categoryId = this.deleteCategoryTargets[0].dataset.categoryId;
    const token = getMetaValue("csrf-token");

    await fetch(`campaign_custom_categories/${categoryId}`, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    window.location.href = `edit`;
  }

  cancelDelete() {
    const modal = document.querySelector(".custom-category__delete-container");
    $(modal).fadeOut("slow");
  }

  edit() {
    const form = document.getElementById("update-category-form");
    form.submit();
  }

  cancelEdit() {
    const modal = document.querySelector(".custom-category__edit-container");
    $(modal).fadeOut("slow");
  }
}

function getMetaValue(name) {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  return element.getAttribute("content");
}
